/**
 * Training slider — native horizontal scroll with optional prev/next controls.
 */
(function () {
  function getCards(carousel) {
    return Array.prototype.slice.call(carousel.querySelectorAll('.training-slider-card'));
  }

  function getNearestIndex(carousel, cards) {
    if (!cards.length) return 0;
    var left = carousel.scrollLeft;
    var nearest = 0;
    var nearestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var dist = Math.abs(cards[i].offsetLeft - left);
      if (dist < nearestDist) {
        nearestDist = dist;
        nearest = i;
      }
    }
    return nearest;
  }

  function scrollToIndex(carousel, cards, index) {
    if (!cards.length) return;
    var clamped = Math.max(0, Math.min(index, cards.length - 1));
    carousel.scrollTo({ left: cards[clamped].offsetLeft, behavior: 'smooth' });
  }

  function syncControls(carousel) {
    var wrap = carousel.closest('[data-training-carousel-wrap]');
    if (!wrap) return;

    var controls = wrap.querySelector('[data-training-controls]');
    var prev = wrap.querySelector('[data-training-prev]');
    var next = wrap.querySelector('[data-training-next]');
    if (!controls || !prev || !next) return;

    var cards = getCards(carousel);
    var maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth - 2);
    var canScroll = maxScroll > 0 && cards.length > 1;

    if (!canScroll) {
      controls.hidden = true;
      return;
    }

    controls.hidden = false;
    prev.disabled = carousel.scrollLeft <= 2;
    next.disabled = carousel.scrollLeft >= maxScroll;
  }

  function enableDragScroll(carousel) {
    if (carousel.dataset.trainingDragBound === 'true') return;
    carousel.dataset.trainingDragBound = 'true';

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    var ignoreClick = false;

    carousel.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.button != null && e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = carousel.scrollLeft;
      carousel.classList.add('is-dragging');
      try {
        carousel.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    carousel.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      carousel.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      carousel.classList.remove('is-dragging');
      if (moved) {
        ignoreClick = true;
        var cards = getCards(carousel);
        scrollToIndex(carousel, cards, getNearestIndex(carousel, cards));
      }
      try {
        if (e && e.pointerId != null) carousel.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    carousel.addEventListener('pointerup', endDrag);
    carousel.addEventListener('pointercancel', endDrag);
    carousel.addEventListener('pointerleave', function (e) {
      if (isDown) endDrag(e);
    });

    carousel.addEventListener(
      'click',
      function (e) {
        if (!ignoreClick) return;
        ignoreClick = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  function bindCarousel(carousel) {
    if (!carousel || carousel.dataset.trainingBound === 'true') return;
    carousel.dataset.trainingBound = 'true';

    var wrap = carousel.closest('[data-training-carousel-wrap]');
    if (!wrap) return;

    var prev = wrap.querySelector('[data-training-prev]');
    var next = wrap.querySelector('[data-training-next]');

    var sync = function () {
      syncControls(carousel);
    };

    carousel.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    if (prev) {
      prev.addEventListener('click', function () {
        var cards = getCards(carousel);
        scrollToIndex(carousel, cards, getNearestIndex(carousel, cards) - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        var cards = getCards(carousel);
        scrollToIndex(carousel, cards, getNearestIndex(carousel, cards) + 1);
      });
    }

    carousel.addEventListener('keydown', function (e) {
      var cards = getCards(carousel);
      var index = getNearestIndex(carousel, cards);
      if (e.key === 'ArrowLeft' || e.key === 'Left') {
        e.preventDefault();
        scrollToIndex(carousel, cards, index - 1);
      } else if (e.key === 'ArrowRight' || e.key === 'Right') {
        e.preventDefault();
        scrollToIndex(carousel, cards, index + 1);
      }
    });

    enableDragScroll(carousel);
    sync();
  }

  function scan() {
    document.querySelectorAll('[data-training-carousel]').forEach(bindCarousel);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-training-carousel]')) {
      e.target.querySelectorAll('[data-training-carousel]').forEach(function (el) {
        el.dataset.trainingBound = '';
        el.dataset.trainingDragBound = '';
      });
      setTimeout(scan, 50);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
